const mediosMap = {
    debit_card: "TARJETA DÉBITO",
    credit_card: "TARJETA CRÉDITO",
    prepaid_card: "TARJETA PREPAGA",
    account_money: "DINERO EN CUENTA MERCADO PAGO",
    ticket: "PAGO EN EFECTIVO",
    bank_transfer: "TRANSFERENCIA BANCARIA"
  };
  
  const tarjetasMap = {
    visa: "VISA",
    master: "MASTERCARD",
    amex: "AMERICAN EXPRESS",
    cabal: "CABAL",
    naranja: "NARANJA",
    tarshop: "TARSHOP",
    mercadopago: "MERCADO PAGO",
    rapipago: "RAPIPAGO",
    pagofacil: "PAGO FÁCIL",
    debvisa: "VISA",
    debmaster: "MASTERCARD",
    debamex: "AMERICAN EXPRESS",
    bbva: "BBVA",
    brubank: "BRUBANK"
  };

  export function obtenerDescripcionPago(medioPago, tarjeta) {
    const medio = mediosMap[medioPago?.toLowerCase()] || "MEDIO DESCONOCIDO";
  
    if (medioPago === "account_money") return medio;
  
    if (!tarjeta || tarjeta.trim() === "") return medio;
  
    const tarjetaKey = tarjeta.toLowerCase().trim();
    const tarjetaNombre = tarjetasMap[tarjetaKey] || tarjeta.toUpperCase();
    const descripcionPago =  `${medio} ${tarjetaNombre}`;
    return descripcionPago;
  }
  